import { isValidCountryCode } from 'src/utils/country';
import {
  BuyerWithSalesDto,
  CreateRetailSaleWithPaymentInput,
  EventWithData,
  ListingDetails,
  PointOfSaleSaleStatus,
  TicketType,
} from 'src/WebApiController';

import { RetailSaleFormValues } from './types';

export const buildRetailSaleInput = (
  values: RetailSaleFormValues,
  listing: ListingDetails | undefined,
  selectedBuyer: BuyerWithSalesDto | undefined,
  event: EventWithData | undefined
): CreateRetailSaleWithPaymentInput => {
  return {
    listingId: values.listingId,
    posEventId: listing?.posEvId ?? '',
    viagogoEventId: listing?.viagEvId ?? null,
    eventMappingId: listing?.viagEvMapId ?? null,
    venueId: event?.event?.venId ?? null,
    saleDate: values.saleDate ?? null,
    currencyCode: values.currencyCode ?? null,
    totalNetProceeds: values.totalNetProceeds ?? null,
    inHandDate: values.inHandDate ?? null,
    quantitySold: values.quantitySold ?? null,
    section: values.section ?? null,
    row: values.row ?? null,
    seatFrom: values.seatFrom ?? null,
    seatTo: values.seatTo ?? null,
    ticketType: (values.ticketType as TicketType) ?? null,
    buyerName: selectedBuyer?.buyerName ?? null,
    buyerEmail: selectedBuyer?.buyerEmail ?? null,
    buyerPhone: selectedBuyer?.buyerPhoneNumber ?? null,
    internalNotes: values.privateNotes ?? null,
    marketplaceSaleId: values.externalSaleId ?? null,
    saleStatus: PointOfSaleSaleStatus.PendingFulfillment,
    lineItems:
      values.marketplacePaymentLines?.map((line) => ({
        paymentLineType: line.paymentLineType,
        amount: line.amount,
        ratePercent: line.ratePercent ?? null,
        reference: line.externalPaymentId || null,
      })) ?? null,
  };
};

export const getPaymentAmount = (values: RetailSaleFormValues) => {
  const { totalNetProceeds, marketplacePaymentLines } = values;
  const marketplaceLinesCost = (marketplacePaymentLines ?? []).reduce(
    (ret, line) => {
      ret += line.amount ?? 0;
      return ret;
    },
    0
  );
  return (totalNetProceeds ?? 0) + marketplaceLinesCost;
};

export const getPaymentCountryCode = (
  selectedBuyer: BuyerWithSalesDto | undefined
) => {
  if (
    selectedBuyer?.billingCountry &&
    isValidCountryCode(selectedBuyer.billingCountry)
  ) {
    return selectedBuyer.billingCountry;
  }

  if (
    selectedBuyer?.shippingCountry &&
    isValidCountryCode(selectedBuyer.shippingCountry)
  ) {
    return selectedBuyer.shippingCountry;
  }

  return 'US';
};
